import React from 'react';
import PropTypes from 'prop-types';
import MultiRateChooser from './MultiRateChooser';

const ParkingOptions = ({
    availableRates,
    selectedRate,
    onMultiRateChange,
    onRateDetailsClick,
}) => {
    return (
        <div className="ParkingOptions">
            <h3 className="ParkingOptions-header">Parking Options</h3>
            <MultiRateChooser
                selectedRate={selectedRate}
                rates={availableRates}
                onMultiRateChange={onMultiRateChange}
                onInfoButtonClick={onRateDetailsClick}
            />
        </div>
    );
};

ParkingOptions.propTypes = {
    availableRates: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedRate: PropTypes.object,
    onMultiRateChange: PropTypes.func,
    onRateDetailsClick: PropTypes.func,
};

export default ParkingOptions;
